"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaiseIssueActionLabel = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const FailIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FailIcon"));
const FlagIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FlagIcon"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    text: {
        paddingLeft: 4,
    },
    boldText: {
        paddingLeft: 4,
        fontWeight: 'bold',
    },
});
function RaiseIssueActionLabel(props) {
    const { action } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const invalidConfig = !(config === null || config === void 0 ? void 0 : config.flag) || !config.title || !config.type;
    const myCss = (0, web_css_1.default)(makeMyClasses, []);
    const faild = `${lib_i18n_1.default.t('disabled')}: ${lib_i18n_1.default.t('missing-required-values')}`;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        invalidConfig ? react_1.default.createElement(FailIcon_1.default, { color: lib_palette_1.default.BadRed, size: 18 }) : null,
        invalidConfig ? (react_1.default.createElement(Text_1.default, { className: myCss.boldText }, faild)) : null,
        !invalidConfig && (config === null || config === void 0 ? void 0 : config.flag) && react_1.default.createElement(FlagIcon_1.default, { color: (0, Flag_1.flagColor)(config === null || config === void 0 ? void 0 : config.flag) }),
        !invalidConfig && (config === null || config === void 0 ? void 0 : config.title) && (react_1.default.createElement(Text_1.default, { className: myCss.text },
            "\"", config === null || config === void 0 ? void 0 :
            config.title,
            "\""))));
}
exports.RaiseIssueActionLabel = RaiseIssueActionLabel;
exports.default = RaiseIssueActionLabel;
